module.exports = __webpack_public_path__ + "img/icon_1_19.29024f73.png";